import { Component, HostBinding, Input, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { getLocation } from '@store/common';
import { getLineageCount, getLineageProperties } from '@store/lineage';
import { getDiscoveryCount, getDiscoveryProperties, getDiscoverySearchObj } from '@store/discovery';
import { getCompareETLCount, getCompareETLProperties } from '@core/states/compare-etl.state';
import { SideBarService } from '@core/services/layout/side-bar.service';
import { CodePreviewService } from '../../../partials/content/general/code-preview/code-preview.service';
import * as _ from 'lodash';
import { ModuleUtilsService } from '@core/services/module-utils.service';
import { PageConfigService } from '@core/services/page-config.service';
import { Locations } from '@shared/enums/locations.enum';
import { filter, map, tap } from 'rxjs/operators';
import { ILayoutState, selectQuickSideBar, SideBarTypes, Status } from '@store/layout';

@Component({
  selector: 'm-quick-sidebar',
  templateUrl: './quick-sidebar.component.html',
  styleUrls: ['./quick-sidebar.component.scss'],
})
export class QuickSidebarComponent implements OnInit, OnDestroy {
  @HostBinding('id') id = 'm_quick_sidebar';
  @HostBinding('class') classes = 'm-quick-sidebar m-quick-sidebar--tabbed m-quick-sidebar--skin-light';
  @Input() title: string;
  public isLarge: boolean = false;
  public quickSideBar$: Observable<any>;
  public sideBarTypes: typeof SideBarTypes = SideBarTypes;
  public sideBarStatus: typeof Status = Status;
  @HostBinding('style.overflow') styleOverflow: any = 'hidden';
  componentDestroy$ = new Subject();
  private defaultTitle: string = ' Sources';
  private location: string;
  private count: string;
  private properties: object;
  private isOpen = false;
  private activeTabId: SideBarTypes = SideBarTypes.connections;
  private locationSearchObj: string;
  private is_empty_location_search_obj: boolean;
  private clickOutSideActive = false;

  constructor(
    private store: Store<ILayoutState>,
    public sideBarService: SideBarService,
    private codePreviewService: CodePreviewService,
    private moduleUtilsService: ModuleUtilsService,
    private pageConfigService: PageConfigService,
  ) {
  }

  ngOnInit(): void {
    this.store
      .pipe(
        select(getLocation),
      )
      .subscribe(location => {
        this.location = location;
        if (this.location !== '') {
          if (location.indexOf('compare') > -1) {
            location = this.moduleUtilsService.getLocationPreferredKey(location);
          }
          this.title = this.moduleUtilsService.getLocationNameToShow(location);
        }
      });

    switch (this.location) {
      case Locations.lineage:
        this.store
          .pipe(
            select(getLineageCount)
          )
          .subscribe(count => {
            this.count = count;
          });

        this.store
          .pipe(
            select(getLineageProperties)
          )
          .subscribe(properties => {
            this.properties = properties;
          });
        break;
      case Locations.discovery:
        this.store
          .pipe(
            select(getDiscoveryCount)
          )
          .subscribe(count => {
            this.count = count;
          });

        this.store
          .pipe(
            select(getDiscoveryProperties)
          )
          .subscribe(properties => {
            this.properties = properties;
          });

        // if show "properties" tab or not
        this.store
          .pipe(
            select(getDiscoverySearchObj)
          )
          .subscribe(search_obj => {
            this.locationSearchObj = search_obj;
            this.is_empty_location_search_obj = _.isEmpty(this.locationSearchObj);
          });
        break;
      case Locations.compare:
        this.store
          .pipe(
            select(getCompareETLCount)
          )
          .subscribe(count => {
            this.count = count;
          });
        // etl or report
        this.store
          .pipe(
            select(getCompareETLProperties)
          )
          .subscribe(properties => {
            this.properties = properties;
          });
        break;
    }

    this.quickSideBar$ = this.store
      .pipe(
        select(selectQuickSideBar),
        filter(data => !!data.type),
        tap((data: any) => {
          this.activeTabId = data?.type;
          if (data.status === Status.open) {
            this.isOpen = true;
            this.classes += ' m-quick-sidebar--on';
          } else {
            this.isOpen = false;
            this.classes = this.classes.replace(/ m-quick-sidebar--on/g, '');
            this.closeLarge();
          }

          this.clickOutSideActive = this.isOpen;
        }),
        map(data => data.type),
      );
  }

  openLarge() {
    this.isLarge = true;
    this.classes += ' m-quick-sidebar--large';
    this.codePreviewService.hosterMode = 'list-properties-large';
    this.pageConfigService.generalHosterMode = 'list-properties-large';
    this.codePreviewService.getCodePreviewStyle();
  }

  closeLarge(isConnectionCloseIt?: boolean) {
    this.isLarge = false;
    this.classes = this.classes.replace(/ m-quick-sidebar--large/g, '');

    if (isConnectionCloseIt) {
      this.codePreviewService.hosterMode = 'list-properties';
      this.pageConfigService.generalHosterMode = 'list-properties';
    } else {
      this.pageConfigService.generalHosterMode = 'map-id';
    }

    this.codePreviewService.getCodePreviewStyle();
  }

  onClose() {
    this.sideBarService.close(SideBarTypes.properties);
    this.isLarge = false;
  }

  onClickOutside() {
    if (this.clickOutSideActive) {
      this.onClose();
    }
  }

    ngOnDestroy(): void {
    }
}
